
import {
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
} from "@mui/material";

const DynamicMultiSelect = ({
  title,
  data,
  selectedItems,
  onChange,
  searchPlaceholder = "Search...",
  isOpen,
  clearData,
  onClose,handleToggle,handleReset
}) => {



  const isItemSelected = (item) => {
    return Object.values(selectedItems)?.some(
      (i) => i.id === item.id
    );

  };



  const renderItemList = (item) => {

    return (
      <Box key={item.id} mt={2}>
       <FormControlLabel
            key={item.id}
            control={
              <Checkbox
                checked={isItemSelected(item)}
                onChange={() => handleToggle(item)}
              />
            }
            label={item.locationName}
          />
      </Box>
    );
  };

  const handleDone = () => {
    onClose();
  };

  return (
    <div className="relative mx-auto    lg:min-w-[200px] w-full ">
      <div className="py-2">
      <Typography variant="h6">{`City Corporation/ Municipility`}</Typography>

       <div className="flex flex-wrap max-h-44  md:max-h-[40vh] overflow-auto"> {data.map((item) => renderItemList(item))}</div>
        <div className="modal-actions">
          {/* <Button onClick={handleResetFilter}>Reset Filter</Button> */}
          <Button onClick={handleReset}>Clear Selection</Button>
          <Button onClick={handleDone} variant="contained">
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DynamicMultiSelect;
